export default "__VITE_ASSET__BPpAouw2__"